import {
  Car,
  HeartPulse,
  Truck,
  ShieldCheck,
  Plane,
  Tractor,
} from "lucide-react";

export const PRODUCTS = [
  {
    slug: "car",
    icon: Car,
    title_en: "Car Insurance",
    title_hi: "कार बीमा",
    desc:
      "Comprehensive protection for your car against accidents, theft, third-party liability and natural calamities.",
    desc_hi: "एक्सीडेंट, चोरी और प्राकृतिक आपदाओं से अपनी कार की पूरी सुरक्षा।",
    image:
      "https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBjYXIlMjBkcml2aW5nfGVufDB8fHx8MTc4MjU0Mzg0NXww&ixlib=rb-4.1.0&q=85",
    bullets: [
      "Zero Depreciation Cover",
      "Cashless Repairs at 5000+ Garages",
      "24x7 Roadside Assistance",
    ],
    color: "from-blue-50 to-blue-100",
    accent: "text-blue-700",
  },
  {
    slug: "health",
    icon: HeartPulse,
    title_en: "Health Insurance",
    title_hi: "स्वास्थ्य बीमा",
    desc:
      "Protect your family from rising medical costs with cashless hospitalization and pre/post-care cover.",
    desc_hi: "बढ़ती मेडिकल लागत से अपने पूरे परिवार की सुरक्षा करें।",
    image:
      "https://images.pexels.com/photos/5888168/pexels-photo-5888168.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    bullets: [
      "Cashless Hospitalization",
      "Family Floater Plans",
      "Pre & Post Hospitalization Cover",
    ],
    color: "from-rose-50 to-rose-100",
    accent: "text-rose-700",
  },
  {
    slug: "truck",
    icon: Truck,
    title_en: "Truck Insurance",
    title_hi: "ट्रक बीमा",
    desc:
      "Specialised commercial vehicle cover for truck owners — protection for goods, vehicle, driver and third-party.",
    desc_hi: "ट्रक मालिकों के लिए विशेष कमर्शियल व्हीकल बीमा।",
    image:
      "https://images.pexels.com/photos/11087837/pexels-photo-11087837.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    bullets: [
      "Goods in Transit Cover",
      "Driver & PA Cover",
      "Claim Support",
    ],
    color: "from-amber-50 to-amber-100",
    accent: "text-amber-700",
  },
  {
    slug: "non-motor",
    icon: ShieldCheck,
    title_en: "Non-Motor Insurance",
    title_hi: "नॉन-मोटर बीमा",
    desc:
      "Property, fire, shop, personal accident and liability cover — keep your business and assets safe.",
    desc_hi: "प्रॉपर्टी, फायर, शॉप और पर्सनल एक्सीडेंट कवर।",
    image:
      "https://images.unsplash.com/photo-1580587771525-78b9dba3b914?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBob3VzZSUyMGV4dGVyaW9yfGVufDB8fHx8MTc4MjU0Mzg3N3ww&ixlib=rb-4.1.0&q=85",
    bullets: [
      "Property & Fire Insurance",
      "Shopkeeper Package",
      "Personal Accident Cover",
    ],
    color: "from-emerald-50 to-emerald-100",
    accent: "text-emerald-700",
  },
  {
    slug: "travel",
    icon: Plane,
    title_en: "Travel Insurance",
    title_hi: "यात्रा बीमा",
    desc:
      "Domestic & international travel protection — medical emergencies, baggage loss, trip cancellation and more.",
    desc_hi: "घरेलू और अंतर्राष्ट्रीय यात्रा के लिए संपूर्ण सुरक्षा।",
    image:
      "https://images.unsplash.com/photo-1592208117290-11096f48f1c7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHx0cmF2ZWxlciUyMGFpcnBvcnQlMjBzbWlsaW5nfGVufDB8fHx8MTc4MjU0Mzg0NXww&ixlib=rb-4.1.0&q=85",
    bullets: [
      "Worldwide Coverage",
      "Lost Baggage Compensation",
      "Trip Cancellation Cover",
    ],
    color: "from-sky-50 to-sky-100",
    accent: "text-sky-700",
  },
  {
    slug: "tractor",
    icon: Tractor,
    title_en: "Tractor Insurance",
    title_hi: "ट्रैक्टर बीमा",
    desc:
      "Made for our farmers — protects tractor, attachments, driver and crops on the move with affordable premium.",
    desc_hi: "किसानों के लिए — ट्रैक्टर और चालक की पूरी सुरक्षा।",
    image:
      "https://images.unsplash.com/photo-1574943320219-553eb213f72d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxpbmRpYW4lMjBmYXJtZXIlMjB0cmFjdG9yfGVufDB8fHx8MTc4MjU0Mzg0NXww&ixlib=rb-4.1.0&q=85",
    bullets: [
      "Comprehensive Damage Cover",
      "Low Premium for Farmers",
      "Quick Rural Claim Settlement",
    ],
    color: "from-lime-50 to-lime-100",
    accent: "text-lime-700",
  },
];

export const PARTNERS = [
  "HDFC ERGO",
  "ICICI Lombard",
  "Bajaj Allianz",
  "TATA AIG",
  "New India",
  "Reliance",
  "SBI General",
  "Star Health",
];

export const BRAND = {
  name: "Beemamen",
  legalName: "VYAS WEALTH TECH PVT LTD",
  logo: "/logo.jpg",
  phones: ["8827794458", "9826982244"],
  email: "support@beemamen.com",
  website: "www.beemamen.com",
  address: "203, Gurukripa Apartment, Near Bharat Petrol Pump, Agar Road, Ujjain (M.P.)",
  tagline_hi: "सुरक्षा का वादा, आपके साथ हमेशा",
  tagline_en: "Your trusted insurance partner",
};
